import yup from "../../../../../../utils/yup";

const tone = yup.string().oneOf(["professional", "casual", "direct"]).required();

export const coPilotSchema = yup.object({
  prompt: yup.string().required(),
  tone: tone.required(),
});

export type CoPilotSchema = yup.InferType<typeof coPilotSchema>;
export type CoPilotTone = yup.InferType<typeof tone>;
